
<template>
    <div class="container-xxl py-5 activities-page">
      <div class="container">
        <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
          <h6 class="section-title text-center text-primary text-uppercase">Faaliyetlerimiz</h6>
          <h1 class="mb-5">
            Hemşehrilerimizi buluşturan <span class="text-primary text-uppercase">etkinlikler</span>
          </h1>
        </div>
        <div class="row g-4">
          <div
            v-for="(activity, index) in ACTIVITIES"
            :key="index"
            class="col-lg-4 col-md-6"
          >
            <article class="activity-card">
              <div class="activity-media">
                <img :src="activity.image" :alt="activity.title" />
              </div>
              <div class="activity-body">
                <h5>{{ activity.title }}</h5>
                <div class="activity-info">
                  <span v-for="(info, idx) in activity.infos" :key="idx">
                    <i :class="`fa ${info.icon} text-primary`"></i>{{ info.text }}
                  </span>
                </div>
                <p>{{ activity.description }}</p>
                <div class="activity-actions">
                  <a class="btn btn-sm btn-outline-primary" href="#">Detayları Gör</a>
                  <a class="btn btn-sm btn-dark" :href="whatsappUrl(activity.title)" target="_blank" rel="noopener">
                    {{ activity.cta }}
                  </a>
                </div>
              </div>
            </article>
          </div>
        </div>
        <p class="activity-credit-note mt-4 mb-0">
          Bazı etkinlik görselleri Wikimedia Commons kaynaklıdır; robotik, sosyal destek, kültürel etkinlik ve iş
          ağı temsili görselleri ilgili açık lisanslarıyla kullanılmıştır.
        </p>
      </div>
    </div>
  </template>
  

  <script setup>
import ACTIVITIES from '@/data/activities'

const whatsappUrl = (activityTitle) => {
  const message = `Derneğinize websitesinden katıldım, ${activityTitle} etkinliği hakkında bilgi almak istiyorum.`
  return `https://wa.me/905079217404?text=${encodeURIComponent(message)}`
}

</script>
